import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/community/visibility.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-fe65311e")

_pushScopeId("data-v-fe65311e")
const _hoisted_1 = { class: "fullModal genericPadding bgWhite fullHeightModal" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "fs_12 greyBlue" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "listButtonContainer my-4 pt-5" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("span", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_modificaimpostazionigruppo",
          text: "Modifica impostazioni gruppo",
          class: "text_uppercase"
        })
      ]),
      _hoisted_5
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", {
          class: "listButton genericShadow",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.permissions && _ctx.permissions(...args)))
        }, [
          _hoisted_8,
          _createVNode(_component_localized_text, {
            class: "fs_14 spaceCadet ms-3",
            localizedKey: "app_permessi",
            text: "Permessi"
          })
        ]),
        _hoisted_9,
        _createVNode("div", {
          class: "listButton genericShadow",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.administrators && _ctx.administrators(...args)))
        }, [
          _hoisted_10,
          _createVNode(_component_localized_text, {
            class: "fs_14 spaceCadet ms-3",
            localizedKey: "app_amministratori",
            text: "Amministratori"
          })
        ]),
        _hoisted_11,
        _createVNode("div", {
          class: "listButton genericShadow",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.moderators && _ctx.moderators(...args)))
        }, [
          _hoisted_12,
          _createVNode(_component_localized_text, {
            class: "fs_14 spaceCadet ms-3",
            localizedKey: "app_moderatori",
            text: "Moderatori"
          })
        ]),
        _hoisted_13,
        _createVNode("div", {
          class: "listButton genericShadow",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.removeGroup && _ctx.removeGroup(...args)))
        }, [
          _hoisted_14,
          _createVNode(_component_localized_text, {
            class: "fs_14 spaceCadet ms-3",
            localizedKey: "app_eliminagruppo",
            text: "Elimina gruppo"
          })
        ])
      ])
    ])
  ]))
})